import {Subheader} from "@/Components";
import {useRef} from "react";
import {Container} from "@/Components";
import {InertiaLink} from "@inertiajs/inertia-react";

const PlanBlock = ({ plan, setModalVisible, currentPlan = null }) => {

    const emmaLightModalRef = useRef(null);

    const includes = plan.list.map((item, i) => <li key={ i } className="text-[#363636] relative ml-2"><img className="absolute -left-6 top-1/2 -translate-y-1/2" src="/images/checkmark.svg"/> { item }</li>)
    const includesScales = plan.listScales.map((item, i) => <li key={ i } className="text-[#363636] relative ml-2"><img className="absolute -left-6 top-1/2 -translate-y-1/2" src="/images/checkmark.svg"/> { item }</li>)
    const includesCustomisable = plan.listCustomisable.map((item, i) => <li key={ i } className="text-[#363636] relative ml-2"><img className="absolute -left-6 top-1/2 -translate-y-1/2" src="/images/checkmark.svg"/> { item }</li>)

    return <>
        <Container size="max-w-[1024px]" className="relative z-20">

            <div className="p-4 mb-8 bg-gray-light shadow-small md:p-16 md:mb-0 md:mr-8 last:md:mr-0">
                <Subheader className="font-normal">{ plan.preTitle }</Subheader>
                <h2 className="mb-[10px] font-bold text-[30px] md:text-[48px] leading-[25px] text-[#363636]">{ plan.name }</h2>

                <p className="my-4 text-[#363636] !max-w-full">{ plan.description }</p>

                <div className="flex flex-col md:flex-row w-full">
                    <div className="w-full md:w-1/3">
                        <Subheader className={"normal-case !font-normal md:!font-semibold !text-[20px] md:!text-[18px] font-roboto"}>{ plan.preTitleStays }</Subheader>
                        <ul className="my-4 ml-4 list-none">{ includes }</ul>
                    </div>

                    <div className="w-full md:w-1/3">
                         <Subheader className={"normal-case !font-normal md:!font-semibold !text-[20px] md:!text-[18px] font-roboto"}>{ plan.preTitleScales }</Subheader>
                         <ul className="my-4 ml-4 list-none">{ includesScales }</ul>
                    </div>

                    <div className="w-full md:w-1/3">
                        <Subheader className={"normal-case !font-normal md:!font-semibold !text-[20px] md:!text-[18px] font-roboto"}>{ plan.preTitleCustomisable }</Subheader>
                        <ul className="my-4 ml-4 list-none">{ includesCustomisable }</ul>
                    </div>
                </div>

                <div className="flex flex-col items-center mt-8 lg:flex-row md:items-end">
                    <div className="flex flex-col gap-4 w-full lg:w-3/5 mb-4">
                        <p className="text-[#363636] text-[24px] leading-[30px] font-bold">{ plan.pricing.price }</p>
                        <p className="text-[#363636] text-[14px]">{ plan.pricing.info }</p>
                    </div>

                    <div className="ml-0 md:ml-auto">

                        <InertiaLink href="/book-a-demo" className="btn-outline border-primary py-3 px-4 mr-4">
                            Book a demo
                        </InertiaLink>

                        <button
                            onClick={ () => {
                                setModalVisible && setModalVisible(true)
                            }}
                            className="btn py-3 px-4"
                            disabled={currentPlan && plan.name.toLowerCase() === currentPlan.toLowerCase()}
                        >
                            { currentPlan && plan.name.toLowerCase() === currentPlan.toLowerCase()
                                ? 'Active plan'
                                : plan.pricing.button
                            }
                        </button>
                    </div>
                </div>
            </div>

        </Container>
    </>
}

export default PlanBlock
